<template>
  <div>
    <LandingHeader />

    <main>
      <section id="hero">
        <HeroSection />
      </section>

      <section >
        <FeatureSection />
      </section>

      <TabbedBentoSection />

    </main>

    <!-- Footer -->
    <footer class="bg-gray-50">
      <FooterSection />
    </footer>
  </div>
</template>

<script setup lang="ts">
import { onMounted } from "vue";
import LandingHeader from "@/Components/LandingHeader.vue";
import HeroSection from "@/Components/Welcome/HeroSection.vue";
import FeatureSection from "@/Components/Welcome/FeatureSection.vue";
import TabbedBentoSection from "@/Components/Welcome/TabbedBentoSection.vue";
import FooterSection from "@/Components/Welcome/FooterSection.vue";
import { Addon } from "@/types/addon";

interface Props {
  addons: Addon[];
}

defineProps<Props>();

onMounted(async () => {
  if (!("scrollBehavior" in document.documentElement.style)) {
    const smoothscroll = await import("smoothscroll-polyfill");
    smoothscroll.polyfill();
  }
});
</script>

<style>
html {
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;
}
</style>
